import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { track } from '../../_core/common/eventTracking/tracker';
import { getUpgradeDataFromUpgradeConfig } from '../../_core/utils/getUpgradeDataFromUpgradeConfig';
import { fetchUpgradePoint, getUpgradeConfigTrackingProperties, warnArchivedUpgradePointUse } from '../utils';
import ResetDate from './ResetDate';
import TooltipProgressBar from './TooltipProgressBar';
import TooltipPurchaseMotionButton from './TooltipPurchaseMotionButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UsageLimitToolTip = ({
  upgradeKey,
  currentUsage,
  usageLimit,
  limitResetDate,
  children,
  usageLimitNextTier
}) => {
  const [hasOpened, setHasOpened] = useState(false);
  const [upgradeData, setUpgradeData] = useState(undefined);
  const onOpen = () => {
    if (hasOpened) return;
    setHasOpened(true);
    fetchUpgradePoint({
      upgradeKey,
      includePurchaseMotions: false
    }).then(upgradeConfig => {
      if (!upgradeConfig) {
        setUpgradeData(null); // Indicate that an error occurred
        console.error('No upgrade config found for upgrade key', {
          upgradeKey
        });
        return;
      }
      setUpgradeData(getUpgradeDataFromUpgradeConfig(upgradeConfig));
      track('interaction', Object.assign({
        action: 'viewed upgrade point'
      }, getUpgradeConfigTrackingProperties(upgradeConfig)));
      if (upgradeConfig.status === 'ARCHIVED') {
        warnArchivedUpgradePointUse(upgradeConfig.upgradeKey);
      }
    }).catch(error => {
      setUpgradeData(null); // Indicate that an error occurred
      console.error(error.message, {
        upgradeKey,
        error
      });
    });
  };
  return /*#__PURE__*/_jsx(Tooltip, {
    "data-test-id": "usage-limit-counter-tooltip",
    use: "longform",
    minInlineSize: "400px",
    maxInlineSize: "500px"
    // onOpen has a catch inside that handles any error
    ,
    onOpenChange: onOpen,
    headingText: isValidI18nKey(`usageLimitCounter.${upgradeKey}.tooltipHeading`) ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: `usageLimitCounter.${upgradeKey}.tooltipHeading`
    }) : null,
    title: /*#__PURE__*/_jsxs("div", {
      children: [limitResetDate && /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(ResetDate, {
          limitResetDate: limitResetDate,
          upgradeKey: upgradeKey
        })
      }), /*#__PURE__*/_jsx(TooltipProgressBar, {
        upgradeKey: upgradeKey,
        currentUsage: currentUsage,
        usageLimit: usageLimit
      }), /*#__PURE__*/_jsx(TooltipPurchaseMotionButton, {
        upgradeData: upgradeData,
        usageLimitBannerData: {
          limit: usageLimit,
          value: currentUsage,
          hasReachedLimit: currentUsage >= usageLimit,
          nextLimit: usageLimitNextTier
        }
      })]
    }),
    children: children
  });
};
export default UsageLimitToolTip;